import { render } from "./login-signals.vue?vue&type=template&id=1bbdec22&scoped=true"
import script from "./login-signals.vue?vue&type=script&lang=js"
export * from "./login-signals.vue?vue&type=script&lang=js"

import "./login-signals.vue?vue&type=style&index=0&id=1bbdec22&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbdec22"]])

export default __exports__